var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMarker = function SvgMarker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 5.083a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5Zm-1.75 3.25a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m9.584 19.79.416-.624-.416.624a.75.75 0 0 0 .832 0L10 19.166l.416.624h.001l.002-.001.005-.004.019-.013.068-.047a23.625 23.625 0 0 0 1.128-.845 26.12 26.12 0 0 0 2.655-2.427c1.905-2.01 3.956-4.902 3.956-8.12a8.25 8.25 0 1 0-16.5 0c0 3.218 2.05 6.11 3.956 8.12a26.11 26.11 0 0 0 3.533 3.095 15.632 15.632 0 0 0 .318.224l.019.013.005.004.003.001ZM5.227 3.56A6.75 6.75 0 0 1 16.75 8.333c0 2.615-1.7 5.14-3.544 7.088A24.604 24.604 0 0 1 10 18.247a24.607 24.607 0 0 1-3.206-2.826C4.95 13.474 3.25 10.948 3.25 8.333A6.75 6.75 0 0 1 5.227 3.56Z",
    fill: "currentColor"
  })));
};
export default SvgMarker;